import React from 'react';

import { DateText } from '@pkg/components/Sections/Admin/Fantasy/GameForm/styles';
interface GameDatesDisplayProps {
    start: string;
    joinEnd: string;
    end: string;
}
export const GameDatesDisplay = ({ start, joinEnd, end }: GameDatesDisplayProps) => {
    return (
        <>
            <div>
                <DateText>Submissions start:</DateText>
                <DateText>Last joining time:</DateText>
                <DateText>Game ends:</DateText>
            </div>
            <div>
                <DateText>
                    <span>[Local time] {start}</span>
                </DateText>
                <DateText>
                    <span>[Local time] {joinEnd}</span>
                </DateText>
                <DateText>
                    <span>[Local time] {end}</span>
                </DateText>
            </div>
        </>
    );
};
